// extracted by css-extract-rspack-plugin
export default {"orderBasicInfoBox":"orderBasicInfoBox-rwXM1P"};